import apiClient from "./apiClient";

export const fetchPlanDetails = async (stripeProductIds) => {
  try {
    const response = await apiClient.post("/billing/plans/specific", {
      stripeProductId: stripeProductIds
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};